import { observer } from 'mobx-react-lite';
import React from 'react';

import { SelectorButton, Popover, Calendar } from '@gem/ui-kit';

import { getLanguage } from 'UTILS/getLanguage';

import { useDatePickerPresenter } from './DatePicker.presenter';
import styles from './DatePicker.styles.m.css';

interface IDatePickerProps {
  title: string;
  date: Date;
  onChangeDate: (date: Date) => void;
}

export const DatePicker: React.FC<IDatePickerProps> = observer((props) => {
  const { presenter, anchorRef } = useDatePickerPresenter({
    onChangeDate: props.onChangeDate,
  });

  return (
    <>
      <SelectorButton
        title={props.title}
        onClick={presenter.onSwitchPicker}
        isActive={presenter.isPickerOpen}
        setRef={anchorRef}
        theme="without-background"
        dataTest="calendar-date-range-select-button"
      />
      <Popover
        isOpened={presenter.isPickerOpen}
        onClose={presenter.onSwitchPicker}
        reference={anchorRef.current}
        placement="bottom-start"
        className={styles.popover}
        modifiers={[
          {
            name: 'offset',
            options: { offset: [0, 0] },
          },
        ]}
      >
        <Calendar
          value={props.date}
          onChange={presenter.onChange}
          className={styles.calendar}
          locale={getLanguage()}
        />
      </Popover>
    </>
  );
});
